export default __webpack_public_path__ + "static/media/board-view.2caba525.svg";